<template>
    <div class="orderList">
            <template v-if="!showFilter">

                <div 
                    v-if="['xs','sm','md'].includes(windowsize.breakpoint)"
                    class="orderDates filterheader" >
                    <div class="orderHeader">
                        <b-row align-v="center">
                            <b-col cols="6">
                               
                            </b-col>

                            <b-col cols="6">
                                <div class="orderAction">
                                    <div 
                                        :class="[{'active' : showFilter}]"
                                        class="orderActionItem">
                                        <span @click="showFilter = !showFilter" class="orderFiller">
                                            <b-icon icon="sliders"></b-icon>
                                        </span>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>

                <template v-for="(group, index) in ordergroup">
                    <div 
                        v-if="checkhasfilter(group)"
                        :key="group.date"
                        class="orderDates" >
                
                        
                        <div 
                            v-if="['xs','sm','md'].includes(windowsize.breakpoint)"
                            class="orderlistmobile">
                             <div class="orderHeader">
                                <b-row align-v="center">
                                    <b-col cols="6">
                                        <template v-if="group.date == 'pastdue'">
                                            <h3>Past Due</h3>

                                        </template>

                                        <template v-else>

                                            <h3>{{group.date | formatreldate}}</h3>
                                        </template>
                                    </b-col>

                                    <b-col cols="6">

                                    
                                    </b-col>
                                </b-row>
                            </div>

                            <order-items 
                                @removeassign="updateorderlist"
                                :amend.sync="amendingorder"
                                :filtered="filteredDriver"
                                :filteredstatus="filteredstatus"
                                :orderlist="group.orders"  />
                        </div>

                        <div 
                            v-if="['lg','xl','xxl'].includes(windowsize.breakpoint)"
                            class="orderlistdesktop">
                            

                            <table 
                                v-if="['lg','xl','xxl'].includes(windowsize.breakpoint)"
                                class="table desktoporderlisttable">
                                <thead >
                                    <tr class="dategrouplabel">
                                        <th colspan="6">
                                            <div class="orderHeader">
                                                <template v-if="group.date == 'pastdue'">
                                                    <h3>Past Due</h3>

                                                </template>

                                                <template v-else>

                                                    <h3>{{group.date | formatreldate}}</h3>
                                                </template>
                                            </div>
                                        </th>
                                    </tr>

                                    <tr 
                                        v-if="index == 0"
                                        class="tableheaderlabels">
                                        <th>
                                            QTY
                                        </th>

                                        <th>
                                            NAME
                                        </th>

                                        <th>
                                            PHONE
                                        </th>

                                        <th>
                                            DELIVERY TIME
                                        </th>

                                        <th>
                                            ADDRESS
                                        </th>

                                        <th>
                                        </th>
                                    </tr>
                                </thead>

                                <order-items-desktop 
                                @removeassign="updateorderlist"
                                :amend.sync="amendingorder"
                                :filtered="filteredDriver"
                                :filteredstatus="filteredstatus"
                                :orderlist="group.orders"  />
                                
                            </table>
                        </div>
                       
                        
                    </div>
                </template>
            </template>

            <template v-if="showFilter">
                <div 
                    class="orderDates" >
                    <div class="orderHeader">
                        <b-row align-v="center">
                            <b-col cols="6">
                                <h3>Filter Orders</h3>
                            </b-col>

                            <b-col cols="6">
                                <div class="orderAction">
                                    <div 
                                        :class="[{'active' : showFilter}]"
                                        class="orderActionItem">
                                        <span @click="showFilter = !showFilter" class="orderFiller">
                                            <b-icon icon="sliders"></b-icon>
                                        </span>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>

                    <order-filter
                        :filteredstatus.sync="filteredstatus" 
                        :filtered.sync="filteredDriver"
                        :orderlist="orders" />
                    
                </div>
            </template>



        <b-modal 
            id="amendorder" 
            centered
            hide-footer 
            hide-header>

            <img src="@/assets/cancelOrder.png" alt="">

            <h1>Amend Delivery?</h1>

            <div class="orderTrail" v-if="amendingorder">
                <div class="orderTrailItem">
                    <span 
                        :class="[`trailType`, {'done' : amendingorder.order.status == 'delivered'}]">
                        <b-icon icon="box-seam"></b-icon>
                    </span>

                    <div class="trailDetails">
                        <h4>Delivered</h4>

                        <p>{{delivereddate(amendingorder) | forceformatdate('h:mm A, MMM D YYYY')}}</p>

                    </div>
                </div>
            </div>

            <p>This will only change the status of the order. The employee assignment will not change.</p>

            <b-form-textarea
                v-model="amendingnotes"
                placeholder="Write..."
                ></b-form-textarea>

             <b-form-checkbox
                v-if="changestatus"
                v-model="ischangestatus"
                :value="true"
                :unchecked-value="false"
                >
                Change delivery status
             </b-form-checkbox>


            <div class="modalAction">
                <button 
                    @click.prevent="$bvModal.hide('amendorder')"
                    class="btn btn-outline-primary">NEVER MIND</button>

                <button 
                     @click.prevent="amendorder"
                    class="btn btn-primary">CONTINUE</button>
            </div>
        </b-modal>
    </div>
</template>

<script>


/**
 * Declerations
 */
// plugins
import moment from 'moment'

// components
import orderListItems from '@/components/admin/orderListItems'
import orderListItemsdesktop from '@/components/admin/orderListItemsdesktop'
import orderListFitler from '@/components/admin/orderListFilter'

// helper 
import Helper from '@/helpers/helper.js'
import {getCollections, newJob, cleanrecord, addUpdateCollection} from '@/helpers/localbase'

// mixin
import {orderboxmixins} from '@/mixins/orderboxmixins'
import {ordermixins} from '@/mixins/ordermixins'
import axios from 'axios'



export default {
    mixins    : [orderboxmixins, ordermixins],
    components: {
        'order-items'        : orderListItems,
        'order-filter'       : orderListFitler,
        'order-items-desktop': orderListItemsdesktop
    },
    props : {
        assignedorders : {
            type   : Array,
            default: () => []
        },
        orderfilteredlist : {
            type   : Array,
            default: () => []
        }
    },
    data() {
        return {
            showFilter    : false,
            ordergroup    : [],
            today         : moment().format('MM/DD/YYYY'),
            orders        : [],
            filteredDriver: [],
            filteredstatus: ['assign', 'accepted', 'delivered', 'amend'],
            amendingorder : null,
            amendingnotes : '',
            changestatus  : false,
            ischangestatus: true,
            pastdueorders : [],
            currentpage   : null,
            fetching      : false
        }
    },
    computed : {
        /**
         * Windowsize
         */
        windowsize() {
            return this.$store.state.windowsize
        },
        /**
         * Socket / webhook
         */
        socketio() {
            return this.$store.state.socketio
        },
       /**
        * Network status
        */
       isonline() {
           return this.$store.state.isonline
       }
    },
    watch : {
        /**
         * Check if amending 
         * then check if change status will be available
         */
        amendingorder() {
            this.checkammendstatus()
        }
    },
    filters : {
        /**
         * Format date by 
         * @param format
         */
        formatdate(date, format) {
            return date ? Helper.formatdate(date, format) : ''
        },
        /**
         * Format date by relation like
         * Today, Tomorrow, and MM/DD/YYYY
         */
        formatreldate(date) {
            return Helper.datestring(date)
        },
         /**
         * Force format date by
         * @param format
         */
        forceformatdate(date, format) {
            return date ? Helper.formatdate(date, format, true) : ''
        },
    },
    methods : {
        /**
         * Continues scroll 
         * fetch unassign list pages when scrolling
         */
        continuesscroll() {
            if(!this.fetching) {
                if(this.currentpage.next_page_url) {
                    this.getallassignedorders(true)
                }
            }
        } ,
        /**
         * Get delivered date
         */
        delivereddate(order) {
            const status = order.order.orderstatuses.find(s => s.status == 'delivered');

            return status ? status.created_at : ''
        },
        /**
         * Desktop filter function 
         */
        filterlist(type) {
            switch (type) {
                case 'pending':
                    this.filteredstatus = this.filteredstatus.includes('pending') || this.filteredstatus.includes('assign') ? this.filteredstatus.filter(s =>  s != 'assign') : [...this.filteredstatus, 'assign']
                    break;

                case 'accepted':
                    this.filteredstatus = this.filteredstatus.includes('accepted') ? this.filteredstatus.filter(s =>  s != 'accepted') : [...this.filteredstatus, 'accepted']
                    this.filteredstatus = this.filteredstatus.includes('amend') ? this.filteredstatus.filter(s =>  s != 'amend') : [...this.filteredstatus, 'amend']
                    break;

                case 'delivered':
                    this.filteredstatus = this.filteredstatus.includes('delivered') ? this.filteredstatus.filter(s =>  s != 'delivered') : [...this.filteredstatus, 'delivered']
                    break;
            
                default:
                    break;
            }

            // set default filter statuses
            this.$emit('update:orderfilteredlist', this.filteredstatus)
        },
         /**
         * Check if ammend update status will be available after 24 hours after last delivery
         * 
         */
        checkammendstatus() {
            const deliverydate = this.amendingorder.order.orderstatuses.find(s => s.status == 'delivered')

            if(deliverydate) {
                this.changestatus = this.pastduration(deliverydate.created_at, 24)
            }
        },
        /**
         * Amend order
         */
        async amendorder() {
            this.$bvModal.hide('amendorder')
            const url = `/update_order_status/${this.amendingorder.order_id}`

            await axios.post(url, {
                status             : 'amend',
                amend_change_status: this.ischangestatus,
                notes              : this.amendingnotes
            })

            this.getallassignedorders();
            
            if(this.socketio) {

                /**
                 * Update history list and broadcast 
                 */
                this.$emit('update', 'history')

                this.socketio.emit('broadcast', {
                    type  : 'assignorder',
                    userid: this.amendingorder.assign_to.id
                })
            }
        },
        /**
         * Check if has filtered result
         * if none don't show group of order
         */
        checkhasfilter(group) {
            const res = group.orders.filter(o => this.filteredDriver.includes(o.assign_to.id) && this.filteredstatus.includes(o.order.status))
            
            return res.length > 0 ? true : false;
        },
        /**
         * Remove from order list the cancelled assignmemtn
         */
        updateorderlist(orderid) {
            this.orders = this.orders.filter(order => order.order_id != orderid)
            this.grouporders()
            this.$emit('update', 'unassigned')
        },
        /**
         * Group order by dates
         */
        grouporders() {
             /**
             * Get past due orders
             */

            this.pastdueorders = this.orders.filter(order => moment(Helper.formatdate(order.order.delivery_date, 'MM/DD/YYYY')).isBefore(Helper.formatdate(moment(), 'MM/DD/YYYY', true)))

            /**
             * Insert past due into  group
             */
            let group  = this.grouporderbydates(this.orders)
            group.unshift( {
                    date  : 'pastdue',
                    orders: this.pastdueorders
                })
            // if(group.length >= 2) {
            //     group.splice(2,0 , {
            //         date  : 'pastdue',
            //         orders: this.pastdueorders
            //     })
            // } else {
            //     group = [...group, {
            //         date  : 'pastdue',
            //         orders: this.pastdueorders
            //     }]
            // }
            this.ordergroup = group
        },
        /**
         * Get assigned  orders
         * pull from indexed db fist
         */
        async getallassignedorders(nextpage = false) {
            this.fetching = true
            const iorders = await getCollections({name : 'assignedorders'})
            // this.orders = iorders

            /**
             * api requires
             */
            let params = {
                page : 1
            }
            if(nextpage) {
                params.page = this.currentpage.current_page + 1
            }

            const url = '/all_assigned_orders'
            const res = await axios.get(url, {params : params}).catch(err => console.log(err));

            if(res.data) {
                this.currentpage = res.data
                let newdata = res.data.data
                this.orders = [...this.orders, ...newdata]

                // let nextpage = res.data.next_page_url

                // while(nextpage) {
                //     const newres = await axios.get(nextpage).catch(err => console.log(err));
                //     if(newres.data) {
                //         nextpage = newres.next_page_url
                //         newdata = [...newdata, ...newres.data.data]
                //     } else {
                //         nextpage = null;
                //     }
                // }

                this.$emit('update:assignedorders', this.orders)

                /**
                 * Update indexed db
                 * and clean trashed data
                 */
                newdata.forEach(d => {
                    addUpdateCollection({name : 'assignedorders', data : d})
                })

                // cleanup
                cleanrecord(newdata, iorders, 'id', 'assignedorders')


            } else if(!this.isonline) {
                /**
                 * If offline add request to job
                 */

                newJob({
                    url   : url,
                    method: "GET",
                    callback : async (data, options) => {
                        if(data) {
                            let newdata  = data.data
                            let nextpage = data.next_page_url

                            while(nextpage) {
                                const newres = await axios.get(nextpage).catch(err => console.log(err));
                                if(newres.data) {
                                    nextpage = newres.next_page_url
                                    newdata = [...newdata, ...newres.data.data]
                                } else {
                                    nextpage = null;
                                }
                            }

                            /**
                             * Update indexed db
                             * and clean trashed data
                             */
                            newdata.forEach(d => {
                                options.db.addUpdateCollection({name : 'assignedorders', data : d})
                            })
                        }
                    }
                })
            }

           
            /**
             * Get employee order ids
             * as default fitlered order
             */
            this.filteredDriver = this.orders.filter((val, index, self) => index == self.findIndex(t => t.assign_to.id == val.assign_to.id)).map(d => d.assign_to.id)

            /**
             * Group orderlist
             */
            this.grouporders()

            this.fetching = false
        }

    },
    /**
     * Run function before component render 
     */
    async beforeMount() {
       
        // Get flavors list
        this.$store.dispatch('getflavors')
        /**
         * Get assigned orders and group by date
         */
        await this.getallassignedorders()
    },
    /**
     * Run function after component render
     */
    mounted() {
       
    }
};
</script>

<style lang="scss">
@import '@/scss/partials/_colors.scss';
@import '@/scss/partials/_mixins.scss';


 .orderTrail {
        padding-left : 30px;

        .orderTrailItem {
            display    : flex;
            border-left: 1px solid $lightgrey2;

            &:last-child {
                border : none;
            }

            .trailType {
                width           : 50px;
                height          : 50px;
                flex            : 0 0 50px;
                margin-right    : 15px;
                margin-left     : -25px;
                border-radius   : 100%;
                display         : flex;
                align-items     : center;
                justify-content : center;
                background-color: $lightgrey;
                font-size       : 25px;

                &.done {
                    background-color: $primaryColor;
                    color           : white;
                }
            }

            .trailDetails {
                h4 {
                    font-size    : 18px;
                    font-weight  : 700;
                    margin-bottom: 0;
                }
            }

            .trailAction {
                margin-left: auto;
                .btn {
                    width  : 130px;
                    height : 40px;
                    padding: 0;
                }
            }
        }
    }

#amendorder {
    .modal-dialog {
        text-align: center;
    }

    .orderTrail {
        display        : flex;
        justify-content: center;
        padding-left   : 0;

        .orderTrailItem {
            display   : block;

            .trailType {
                margin-right: auto;
                margin-left : auto;
                width       : 35px;
                height      : 35px;
                font-size   : 15px;
            }
        }
    }
}

.orderList {
    position      : relative;
    padding-bottom: 30px;

    .filterheader {
        position: absolute;
        top     : 25px;
        right   : 15px;

        .orderHeader {
            padding-top : 0;
        }
    }

    .orderHeader {
        padding-top : 30px;

        h3 {
            color        : $primaryColor;
            font-size    : 15px;
            font-weight  : 700;
            margin-bottom: 0;
        }

        .orderAction {
            display        : flex;
            align-items    : center;
            justify-content: flex-end;
            padding-right  : 15px;

            .orderActionItem {
                cursor: pointer;

                &.active {
                    color : $primaryColor;
                }
                
                .orderFiller {
                    font-size: 20px;
                }
                
            }
        }
    }

    .orderItems {
        
        .orderTrail {
            .amendstatuses {
                svg {
                    font-size : 14px;
                }
                
                .orderstatus {

            
                    p {
                        text-transform: none;
                    }
                }
            }
        }
        

        .accordion {
            .card {
                border    : none;
                margin-top: 30px;

                header {
                    border-left     : 4px solid transparent;

                    &.assign, &.pending {
                        border-color : $primaryColor;
                    }

                    &.delivered {
                        border-color: $green;
                    }

                    .collapseIcon {
                        height         : 100%;
                        display        : flex;
                        align-items    : center;
                        justify-content: flex-end;
                                                
                        svg[aria-label~=up] {
                            visibility: hidden;
                        }

                        svg[aria-label~=down] {
                            visibility: visible;
                        }
                    }

                    .not-collapsed {
                        .collapseIcon {
                            svg[aria-label~=up] {
                                visibility: visible;
                            }

                            svg[aria-label~=down] {
                                visibility: hidden;
                            }
                                
                        }
                        
                    }

                    .orderDetails {
                        display: flex;

                        .deliveryInfo {
                            display     : flex;
                            align-items : center;
                            margin-right: 15px;

                            .deliveryInfoItem {
                                width        : 50px;
                                height       : 50px;
                                border-radius: 100%;

                                &.orderSize {
                                    background-color: $lightgrey3;
                                    display         : flex;
                                    align-items     : center;
                                    justify-content : center;
                                    flex-direction  : column;
                                    margin-left     : -10px;
                                    border          : 2px solid white;

                                    span {
                                        display    : block;
                                        font-weight: 800;

                                        &:last-child {
                                            font-size : 9px;
                                        }
                                    }
                                }

                                &.deliveryUser {
                                    .deliveryImage {
                                        width              : 100%;
                                        height             : 100%;
                                        border-radius      : 100%;
                                        background-size    : cover;
                                        background-position: center;
                                    }
                                }
                            }
                        }

                        .orderName {
                            h4 {
                                font-size  : 20px;
                                font-weight: 700;
                            }

                            p {
                                margin-bottom: 0;
                                color        : $grey;
                            }
                        }
                    }
                    
                }

                .card-body {
                   

                    .orderContactDetails {
                        border-top   : 1px solid $lightgrey2;
                        border-bottom: 1px solid $lightgrey2;
                        padding      : 30px 0;
                        color        : $grey;

                        .contactItem {
                            margin-bottom : 10px;

                            .orderNote {
                                background-color: lighten($color: $primaryColor, $amount: 59);
                                padding         : 15px;
                            }
                        }
                    }

                    .orderSummary {
                        padding-top : 30px;

                        .orderSummaryHeader {
                            margin-bottom : 20px;

                            h4 {
                                font-size    : 18px;
                                font-weight  : 800;
                                margin-bottom: 0;
                            }

                            .dozen {
                                font-weight: 800;
                                color      : $grey;
                                text-align: left;
                            }
                        }

                        .orderBreakdown {
                            padding-left : 15px;

                            .orderBreakdownItem {
                                color        : $primaryColor;
                                font-size    : 15px;
                                margin-bottom: 10px;
                                
                                .orderNumber {
                                    font-weight: 700;
                                }
                            }
                        }
                    }
                }

                .orderDelivered {
                    padding-top   : 15px;
                    padding-bottom: 15px;

                    .deliveredAction {
                        display: flex;
                        margin-bottom : 30px;

                        .btn {
                            flex   : 1;
                            padding: 5px 0;
                            height : initial;
                            
                            &:first-child {
                                margin-right : 10px;
                            }

                            &:last-child {
                                margin-left: 10px;
                            }
                        }
                    }
                    
                    .deliveryProof {
                        img {
                            width       : 100%;
                            max-width   : 200px;
                            margin-left : auto;
                            margin-right: auto;
                            display     : block;
                        }
                    }
                }

                .collapse {
                    &.show {
                        border-bottom : 10px solid $lightgrey;
                    }
                }
            }
        }
    }   

     .desktoporderlisttable {

        td, th {
            border        : none;
            vertical-align: middle;
        }

        .tableheaderlabels {
            th {
                font-size  : 15px;
                font-weight: 700;

                &:first-child {
                    padding-left : 70px;
                }
            }
        }

        tbody {
            tr {
                background-color: #fff;

                &.moredtailsrow {
                    border-top : 1px solid darken($lightgrey, 10);
                }

                &.space {
                    background-color: transparent;
                    td {
                        padding : 5px 0;
                    }
                }

                &.assigningorder {
                    border : 2px solid $primaryColor;
                }

                td {

                    .bi-circle {
                        color : $lightgrey2;
                    }

                    &:first-child {
                        padding-left : 70px;
                    }

                    &:nth-child(3), &:nth-child(4) {
                        white-space: nowrap;
                    }

                }
                
            }
        }
    }
}
</style>
